/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scheduledchangetitle2Inputs */

const en_scheduledchangetitle2 = /** @type {(inputs: Scheduledchangetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled change`)
};

const de_scheduledchangetitle2 = /** @type {(inputs: Scheduledchangetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplanter Wechsel`)
};

/**
* | output |
* | --- |
* | "Scheduled change" |
*
* @param {Scheduledchangetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const scheduledchangetitle2 = /** @type {((inputs?: Scheduledchangetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scheduledchangetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_scheduledchangetitle2(inputs)
	return de_scheduledchangetitle2(inputs)
});
export { scheduledchangetitle2 as "scheduledChangeTitle" }